import { asrConfig } from "./config";

// 音波识别
export function analyser(canvasElt, isLeftToRight = true, globalStatus) {
  const audioCtx = globalStatus.audioCtx;
  const audioStream = globalStatus.audioStream;

  const rect = canvasElt.current.getBoundingClientRect();
  const canvasH = rect.height;
  const canvasW = 4 * canvasH;

  const analyser = audioCtx.createAnalyser();
  analyser.fftSize = 512;
  const source = audioCtx.createMediaStreamSource(audioStream);

  source.connect(analyser);
  // 不连接输出设备, 防止有杂音
  // analyser.connect(audioCtx.destination)

  const bufferLength = analyser.frequencyBinCount;
  const dataArray = new Uint8Array(bufferLength);

  canvasElt.current.width = canvasW;
  canvasElt.current.height = canvasH;
  canvasElt.current.style.width = `${canvasW}px`;
  canvasElt.current.style.height = `${canvasH}px`;
  const ctx = canvasElt.current.getContext("2d");
  // ctx.scale(window.devicePixelRatio, window.devicePixelRatio)
  const len = 10;
  const gapW = Math.floor(canvasW / (2 * len));
  const barW = Math.floor(gapW);
  let barH;

  const colorArr = [
    "rgba(69, 123, 255, 1)",
    "rgba(76, 138, 243, 1)",
    "rgba(79, 145, 237, 1)",
    "rgba(81, 150, 231, 1)",
    "rgba(86, 158, 223, 1)",
    "rgba(117, 171, 223, 1)",
    "rgba(123, 177, 217, 1)",
    "rgba(145, 198, 238, 1)",
  ];

  function renderFrame() {
    analyser.getByteFrequencyData(dataArray);

    ctx.clearRect(0, 0, canvasW, canvasH);

    const sign = isLeftToRight ? 1 : -1;
    let x;
    if (isLeftToRight) {
      x = gapW;
    } else {
      x = canvasW - gapW;
    }
    for (let i = 0; i < len; i++) {
      const idx = Math.floor(bufferLength / len) * i;
      barH = Math.floor((canvasH * dataArray[idx]) / 255);
      if (barH >= canvasH / 2 - barW / 2) {
        barH = Math.floor(
          canvasH / 2 - barW / 2 - (Math.random() * canvasH) / 10
        );
      }
      ctx.fillStyle = colorArr[i];
      ctx.strokeStyle = colorArr[i];
      // 矩形
      ctx.fillRect(x, canvasH / 2 - barH, sign * barW, barH * 2);
      // 下半圆
      ctx.beginPath();
      ctx.arc(
        x + (sign * barW) / 2,
        canvasH / 2 + barH,
        barW / 2,
        0,
        Math.PI,
        false
      );
      ctx.moveTo(x, canvasH / 2 + barH);
      ctx.lineTo(x + sign * barW, canvasH / 2 + barH);
      ctx.closePath();
      ctx.stroke();
      ctx.fill();
      // 上半圆
      ctx.beginPath();
      ctx.arc(
        x + (sign * barW) / 2,
        canvasH / 2 - barH,
        barW / 2,
        0,
        Math.PI,
        true
      );
      ctx.moveTo(x, canvasH / 2 - barH);
      ctx.lineTo(x + sign * barW, canvasH / 2 - barH);
      ctx.closePath();
      ctx.stroke();
      ctx.fill();
      x += (barW + gapW) * sign;
    }

    requestAnimationFrame(renderFrame);
  }

  renderFrame();
}

// ASR鉴权函数
export function signCallback(signStr) {
  function toUint8Array(wordArray) {
    // Shortcuts
    const words = wordArray.words;
    const sigBytes = wordArray.sigBytes;

    // Convert
    const u8 = new Uint8Array(sigBytes);
    for (let i = 0; i < sigBytes; i++) {
      u8[i] = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
    }
    return u8;
  }
  function Uint8ArrayToString(fileData) {
    let dataString = "";
    for (let i = 0; i < fileData.length; i++) {
      dataString += String.fromCharCode(fileData[i]);
    }
    return dataString;
  }

  const secretKey = asrConfig.secretKey;
  const hash = window.CryptoJSTest.HmacSHA1(signStr, secretKey);
  const bytes = Uint8ArrayToString(toUint8Array(hash));
  return window.btoa(bytes);
}

export function getUserId() {
  const currentTmpUserId =
    localStorage.getItem("currentTmpUserId") ||
    `${parseInt(Math.random() * 1000000000)}`;
  if (!localStorage.getItem("currentTmpUserId")) {
    localStorage.setItem("currentTmpUserId", currentTmpUserId);
  }
  return currentTmpUserId;
}

export function filterText(inputText) {
  const isCanEnd = /[^\u4e00-\u9fa5a-zA-Z0-9%\s《》（）()“”""]/.test(inputText);

  const filteredText = inputText.replace(/[^\u4e00-\u9fa5a-zA-Z0-9%]/g, "");
  return {
    text: filteredText,
    canEnd: isCanEnd,
  };
}

export const enterFullScreen = (setIsFullScreen) => {
  const element = document.documentElement;
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
  setIsFullScreen(true);
};

export const exitFullScreen = (setIsFullScreen) => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
  setIsFullScreen(false);
};
